/* @flow */

import React from 'react';
import styled from 'styled-components';

import FlexBox from './FlexBox';

const CountDownBox = styled(FlexBox)`
  > span {
    line-height: 100%;
  }
`;

type Props = {
  seconds: number,
  onCountDownEnd: Function,
};

type State = {
  H: string | number,
  M: string | number,
  S: string | number,
};

export default class CountDown extends React.Component<Props, State> {
  static defaultProps = {
    onCountDownEnd: () => {},
  };

  state = {
    H: '00',
    M: '00',
    S: '00',
  };

  componentDidMount() {
    let { seconds } = this.props;
    const timer = setInterval(() => {
      seconds--;
      if (seconds < 0) {
        clearInterval(timer);
        this.props.onCountDownEnd();
        return;
      }
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds / 60) % 60);
      const s = Math.floor(seconds % 60);
      this.setState({
        H: h > 9 ? h : `0${h}`,
        M: m > 9 ? m : `0${m}`,
        S: s > 9 ? s : `0${s}`,
      });
    }, 1000);
  }

  render() {
    const { H, M, S } = this.state;
    return (
      <CountDownBox>
        <span>
          {H}:{M}:{S}
        </span>
      </CountDownBox>
    );
  }
}
